export default __webpack_public_path__ + "1046e15600ab8a0b1f0d9b7b1f5e9cc0.woff2";